import { PresentationApprovableBusinessFunctionDto } from '@backbase/data-ang/approvals';

export const businessFunctionByOriginalName: { [x: string]: string } = {
  'Assign Approval Policies': '1032',
  'Unlock User': '1050',
  'Batch - SEPA CT': '1037',
  'Manage Users': '1010',
  'Manage Data Groups': '1019',
  'Manage Service Agreements': '1028',
  'BanescoDR Bss Banesco TDC Transf': 'banescoDR.1015',
  'BanescoDR Bss Regional Transf': 'banescoDR.1020',
  Transactions: '1003',
  'Product Summary': '1006',
  'Manage Legal Entities': '1011',
  'Manage Limits': '1012',
  'BanescoDR Bss Banesco Loan Trans': 'banescoDR.1016',
  'BanescoDR Bss Within Bank Transf': 'banescoDR.1019',
  'Manage Function Groups': '1020',
  'Assign Users': '1007',
  'BanescoDR Bss Banesco Transf': 'banescoDR.1014',
  Audit: '1013',
  'Lock User': '1049',
  'Assign Permissions': '1009',
  'Manage Authorized Users': '1078',
  'Manage Identities': '1034',
  'Manage Approval Policy and Level': '1033',
  'Manage User Profiles': '1035',
  Contacts: '1005',
  'Manage Statements': '1016',
  'BanescoDR Bss Taxes Transf': 'banescoDR.1024',
  'Manage Global Limits': '1040',
  'BanescoDR Bss Internation Transf': 'banescoDR.1021',
  'Manage Devices': '1051',
  "Manage Other User's Devices": '1066',
  'BanescoDR Bss W Bank Loan Transf': 'banescoDR.1018',
  'BanescoDR Bss Stock Transf': 'banescoDR.1022',
  'BanescoDR Bss Recharge Service': 'banescoDR.1025',
  'BanescoDR Bss Services Transf': 'banescoDR.1023',
  'Revoke access': '1084',
  'BanescoDR Bss W Bank TDC Transf': 'banescoDR.1017',
  'Manage Notifications': '1030',
  'Manage Self-approve Permissions': '1119'
};
export class BusinessFunctionUtils {
  readonly availableBusinessFunctions: { [key: string]: string } = {
    '1016': $localize`:@@business-function.name.manage-statements:Manage Statements`,
    '1037': $localize`:@@business-function.name.batch-sepa-ct:Batch - SEPA CT`,
    'banescoDR.1014': $localize`:@@business-function.name.banescodr-bss-banesco-transf:BanescoDR Bss Banesco Transf`,
    'banescoDR.1015': $localize`:@@business-function.name.banescodr-bss-banesco-tdc-transf:BanescoDR Bss Banesco TDC Transf`,
    'banescoDR.1016': $localize`:@@business-function.name.banescodr-bss-banesco-loan-trans:BanescoDR Bss Banesco Loan Trans`,
    'banescoDR.1017': $localize`:@@business-function.name.banescodr-bss-w-bank-tdc-transf:BanescoDR Bss W Bank TDC Transf`,
    'banescoDR.1018': $localize`:@@business-function.name.banescodr-bss-w-bank-loan-transf:BanescoDR Bss W Bank Loan Transf`,
    'banescoDR.1019': $localize`:@@business-function.name.banescodr-bss-within-bank-transf:BanescoDR Bss Within Bank Transf`,
    'banescoDR.1020': $localize`:@@business-function.name.banescodr-bss-regional-transf:BanescoDR Bss Regional Transf`,
    'banescoDR.1021': $localize`:@@business-function.name.banescodr-bss-internation-transf:BanescoDR Bss Internation Transf`,
    'banescoDR.1022': $localize`:@@business-function.name.banescodr-bss-stock-transf:BanescoDR Bss Stock Transf`,
    'banescoDR.1023': $localize`:@@business-function.name.banescodr-bss-services-transf:BanescoDR Bss Services Transf`,
    'banescoDR.1024': $localize`:@@business-function.name.banescodr-bss-taxes-transf:BanescoDR Bss Taxes Transf`,
    'banescoDR.1025': $localize`:@@business-function.name.banescodr-bss-recharge-service:BanescoDR Bss Recharge Service`,
    '1006': $localize`:@@business-function.name.product-summary:Product Summary`,
    '1003': $localize`:@@business-function.name.transactions:Transactions`,
    '1005': $localize`:@@business-function.name.contacts:Contacts`,
    '1032': $localize`:@@business-function.name.assign-approval-policies:Assign Approval Policies`,
    '1033': $localize`:@@business-function.name.Manage Approval Policy and Level:Manage Approval Policy and Level`,
    '1013': $localize`:@@business-function.name.audit:Audit`,
    '1019': $localize`:@@business-function.name.manage-data-groups-manage-account-and-payee-groups:Manage Data Groups`,
    '1020': $localize`:@@business-function.name.manage-function-groups-job-roles:Manage Function Groups`,
    '1011': $localize`:@@business-function.name.manage-legal-entities:Manage Legal Entities`,
    '1012': $localize`:@@business-function.name.manage-limits:Manage Limits`,
    '1040': $localize`:@@business-function.name.manage-global-limits:Manage Global Limits`,
    '1007': $localize`:@@business-function.name.assign-users-manage-users-in-service-agreement:Assign Users`,
    '1009': $localize`:@@business-function.name.assign-permissions:Assign Permissions`,
    '1028': $localize`:@@business-function.name.manage-service-agreements:Manage Service Agreements`,
    '1010': $localize`:@@business-function.name.manage-users:Manage Users`,
    '1078': $localize`:@@business-function.name.manage-authorized-users:Manage Authorized Users`,
    '1035': $localize`:@@business-function.name.manage-user-profiles:Manage User Profiles`,
    '1051': $localize`:@@business-function.name.manage-devices:Manage Devices`,
    '1066': $localize`:@@business-function.name.manage-other-users-devices:Manage Other User's Devices`,
    '1034': $localize`:@@business-function.name.manage-identities:Manage Identities`,
    '1049': $localize`:@@business-function.name.lock-user:Lock User`,
    '1050': $localize`:@@business-function.name.unlock-user:Unlock User`,
    '1084': $localize`:@@business-function.name.revoke-access:Revoke access`,
    '1030': $localize`:@@business-function.name.manage-notifications:Manage Notifications`,
    '1119': 'Manage Self-approve Permissions'
  };

  filterValidFunctionGroups(businessFunction: any[], key: string): any[] {
    const availableBusinessFunctionsIds = Object.keys(this.availableBusinessFunctions);
    return businessFunction.filter((data) => availableBusinessFunctionsIds.includes(data[key]));
  }

  getFunctionName(businessFunctionId: string): string {
    if (!businessFunctionId) {
      return '';
    }
    return this.availableBusinessFunctions[businessFunctionId] || businessFunctionId;
  }

  getBusinessFunctionWithTranslations(
    availableBusinessFunctions: PresentationApprovableBusinessFunctionDto[],
  ): PresentationApprovableBusinessFunctionDto[] {
    return availableBusinessFunctions.map((bs) => {
      const functionName = this.getFunctionName(businessFunctionByOriginalName[bs.function]);
      return { ...bs, additions: { ...bs.additions, functionName } };
    });
  }

  getValidFunctionsAndName(businessFunction: any[], key: string): any[] {
    return this.filterValidFunctionGroups([...businessFunction].slice(), key).map((data) => {
      data[key] = this.getFunctionName(data[key]);
      return data;
    });
  }
}
